
import { Badge } from "@/components/ui/badge";
import { Clock, AlertTriangle } from "lucide-react";
import { useEventDeadline } from "@/hooks/useEventDeadline";

interface UrgencyBadgeProps {
  deadline: string;
  label?: string;
  guestRsvpComplete?: boolean;
  hasRecommendations?: boolean;
}

export const UrgencyBadge = ({ 
  deadline, 
  label, 
  guestRsvpComplete = false,
  hasRecommendations = false
}: UrgencyBadgeProps) => {
  const { showBadge, isExpired, timeRemaining } = useEventDeadline(
    deadline,
    guestRsvpComplete,
    hasRecommendations
  );
  
  // Don't render anything if we shouldn't show a badge
  if (!showBadge) return null;
  
  // If deadline has passed, show "Deadline passed" badge
  if (isExpired) {
    return (
      <Badge 
        variant="outline" 
        className="bg-red-100 text-red-800 border-red-200 gap-1 font-normal"
      >
        <AlertTriangle size={12} className="mr-1" />
        Deadline passed
      </Badge>
    );
  }
  
  // Show active deadline with remaining time
  return (
    <Badge 
      variant="outline" 
      className="bg-orange-100 text-orange-800 border-orange-200 gap-1 font-normal"
    >
      <Clock size={12} className="mr-1" />
      {timeRemaining}{label ? ` ${label}` : ''}
    </Badge>
  );
};
